import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ChatOrganization } from '../../domain/models/organization.model';
import { IOrganizationsRepository } from '../../domain/repositories/organizations.repository';
import { OrganizationsRemoteDatasource } from '../datasources/remote/organizations.remote-datasource';
import { OrganizationMapper } from '../mappers/organization.mapper';

@Injectable()
export class OrganizationsRepositoryImpl implements IOrganizationsRepository {
  private readonly datasource = inject(OrganizationsRemoteDatasource);
  private readonly mapper = inject(OrganizationMapper);

  public list(): Observable<readonly ChatOrganization[]> {
    return this.datasource.list().pipe(
      map((dtos) => dtos.map((dto) => this.mapper.toOrganization(dto))),
    );
  }
}
